import styled from 'styled-components/macro';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const LoaderContainer = styled.div`
  ${FLEX_CONTAINER.FlexCenterColumn};
  width: 100%;
`;
